module.exports = __webpack_public_path__ + "static/img/West.0b0eaf78.png";